import Vue from 'vue'

//中央事件总线
export default new Vue();